import { APIPromise } from "services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { AlertTriggerDTO, CreateStandaloneTriggerRequest } from "./model/alerts/alert-types";

class AlertTriggersApiDefinition extends ApiDefinition {
  constructor() {
    super("/alerts/triggers");
  }

  async getAllTriggers(companyReference: string): APIPromise<AlertTriggerDTO[]> {
    return this.get(`company/${companyReference}`);
  }

  async getTrigger(triggerId: number): APIPromise<AlertTriggerDTO> {
    return this.get(`${triggerId}`);
  }

  async createTrigger(trigger: CreateStandaloneTriggerRequest): APIPromise<AlertTriggerDTO> {
    return this.post(null, trigger);
  }

  async updateTrigger(
    triggerId: number,
    trigger: CreateStandaloneTriggerRequest
  ): APIPromise<AlertTriggerDTO> {
    return this.put(`${triggerId}`, trigger);
  }

  async deleteTrigger(triggerId: number): APIPromise<void> {
    return this.delete(`${triggerId}`);
  }
}

const AlertTriggersApi = new AlertTriggersApiDefinition();
export default AlertTriggersApi;
